import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { groupBy} from "lodash";
import { ChevronDownIcon } from "@/icons/solid";

const CostCentersByLevel = ({
	data,
}) => {
	const [toggle, setToggle] = useState(false);

	return (
		<>
			<div
				className="col-xs-2 pull-left"
				style={{ marginBottom: 10 }}
			>
				{data ? (
					<button
						type="button"
						onClick={() => setToggle(!toggle)}
						className="btn pull-left"
						style={{ background: "#ea611c", color: "#fff" }}
					>
						{`Show Cost Centers by Level `}
						<ChevronDownIcon
							style={{
								height: "1.5em",
								margin: "-5",
								marginLeft: 5,
								marginTop: 0,
								transform: toggle ? "rotateX(180deg)" : "rotateX(0deg)",
								transition: "transform 0.3s ease-in-out",
							}}
						/>
					</button>
				) : null}
			</div>
			<div className="col-xs-12" style={{marginBottom: 10}}>
				{toggle ? (
					<>
						{Object.keys(data)?.map((level) => {
							return <CenterDisplay data={data[level]} key={level} level={level} />;
						})}
					</>
				) : null}
			</div>
		</>
	);
};

const CenterDisplay = ({ data, level }) => {
	return (
		<>
			<div style={{marginTop: 30}}>
				<h3 style={{ marginBottom: 10 }}>{`Level ${level}`}</h3>
				<div
					className="col-xs-12"
					style={{ padding: 0 }}
				>
					<table className="table table-borderless">
						<thead style={{ background: "#ea611c", color: "#fff" }}>
							<tr>
								<th scope="col" style={{width: "50%"}}>Code</th>
								<th scope="col" style={{width: "50%"}}>Name</th>
							</tr>
						</thead>
						<tbody style={{ background: "#fff"}}>
							{data?.map((center) => (
								<tr style={{borderBottom: "solid 1px rgb(244, 244, 244)"}}>
									<td>{center?.Code || "N/A"}</td>
									<td>{center?.Name || "N/A"}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {

	const data = state?.accounting?.costCenters?.data || []

	const dataByLevel = groupBy(data, "Level")

	return {
		data: dataByLevel,
	};
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(CostCentersByLevel);
